module.exports = `${require.publicPath}about-img01.dd03ac32.png`;